import React from 'react';
import styled from 'styled-components';

import { t } from 'i18next';
import { useHistory } from 'react-router';
import Gomilka from '../../../../../asset/mama/gomilka.png';
import Iphone from '../../../../../asset/mama/iphone.png';
import Starfall from '../../../../../asset/mama/starfall.png';
import HeroCardOne from '../../../../../asset/svg/mama-page/hero-card-one.svg';
import HeroCardTwo from '../../../../../asset/svg/mama-page/hero-card-two.svg';
import { TextElem } from '../../../../../common/text';
import { MamaButton } from '../../promo-button';

export const Hero: React.FC<{}> = ({ }) => {

  const history = useHistory();
  const onRegisterBtnClick = () => {
    history.push('/');
    setTimeout(() => {
      document.getElementById('mama-form')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  }

  return (
    <Container>
      <GomilkaImage src={Gomilka} />
      <FlexStyled direction="column" gap={20}>
        <IphoneImage src={Iphone} />
        <StarfallImage src={Starfall} />
        <PromoBadge>
          <div className="dot" />
          <span className="text">{t("MAMA.HOME.PROMO_DURATION")}</span>
        </PromoBadge>

        <FlexStyledText direction="column">
          <HeroTextContainer>
            <MamaTextLogo
              color="white"
              size="heroSubtitle"
              type="extra-bold"
              tid="MAMA.HOME.LEFT_TITLE"
            />
          </HeroTextContainer>
          <HeroTextContainer2>
            <MamaTextLogo
              color="white"
              size="heroSubtitle"
              type="extra-bold"
              tid="MAMA.HOME.RIGHT_TITLE"
            />
          </HeroTextContainer2>
        </FlexStyledText>
        <MobileRegisterButtonHolder>
          <RegisterMamaButton onClick={onRegisterBtnClick} color='orange' tid='MAMA.HOME.REGISTER_CODE_MOBILE' size='large' />
          <MobileGomilkaImage src={Gomilka} />
        </MobileRegisterButtonHolder>
        <FlexCards direction="column" align="start" gap={10}>
          <HeroCardTop>
            <HeroCardImage src={HeroCardOne} />
            <HeroCardText color="white" size="signature" tid="MAMA.HOME.SUBTITLE_ONE" />
          </HeroCardTop>
          <HeroCardBottom>
            <HeroCardImage src={HeroCardTwo} />
            <HeroCardText color="white" size="signature" tid="MAMA.HOME.SUBTITLE_TWO" />
          </HeroCardBottom>
        </FlexCards>
        <RegisterButtonHolder>
          <RegisterMamaButton onClick={onRegisterBtnClick} color='orange' tid='MAMA.HOME.REGISTER_CODE' size='large' />
          <MobileGomilkaImage src={Gomilka} />
        </RegisterButtonHolder>
      </FlexStyled>

    </Container>
  );
};

const FlexContainer = styled.div<{
  gap?: number;
  direction?: 'column' | 'row';
  align?: 'start' | 'end' | 'center';
}>`
  width: 100%;
  display: flex;
  align-items: ${({ align = 'center' }) => align};
  flex-direction: ${({ direction }) => direction};
  gap: ${({ gap }) => `${gap}px`};
`;

const FlexStyled = styled(FlexContainer)`
  position: relative;
  gap: 23px;
  @media screen and (max-width: 1080px) {
    /* position:initial; */
  }
`;

const FlexStyledText = styled(FlexStyled)`
  @media screen and (max-width: 615px) {
    gap: 0px;
  }
`;

const TextStyled = styled(TextElem)`
  font-family: "Dela Gothic One" !important;
`;

const HeroTextContainer = styled.div`
width: 100%;
display: flex;
flex-direction: column;
`;

const HeroTextContainer2 = styled(HeroTextContainer)`
align-items: end;
padding-right: 0px;

@media screen and (max-width: 615px) {
  align-items: initial;
}
`;


export const MamaText = styled(TextStyled)`
line-height: 0.92em !important;
text-transform: uppercase;
  text-shadow: 0px 14px 20px rgba(98, 0, 45, 0.8);
  font-weight: 400;
`;

export const MamaTextLogo = styled(MamaText)`
  line-height: 0.92em !important;
  text-transform: uppercase;
  text-shadow: 0px 14px 20px #62002DCC;
  font-weight: 400;



  @media screen and (min-width: 615px) and (max-width: 1074px) {
    font-size: 50px;
  }
  @media screen and (max-width: 615px) {
    font-size: 27px;
  }

  @media screen and (max-width: 358px) {
    font-size: 20px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;

    @media screen and (max-width: 615px) {
    /* min-height: calc(100vh - 176px); */
  }
`;

export const PromoBadge = styled.div`
  /* position: absolute; */
  align-self: start;
  height: 32px;
  left: 0px;
  top: 9px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  padding: 6px 16px;

  background: #1c1a1a;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.32);
  border-radius: 56px;

  .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;

    background: #e92f2f;
    box-shadow: 0px 0px 9px #ea1f1f,
      inset 0px 3px 2px rgba(255, 255, 255, 0.15);

    flex: none;
  }

  .text {
    font-family: "RF Dewi";
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #ffffff;

    white-space: nowrap;
  }
`;

const IphoneImage = styled.img`
  position: absolute;
  right: -115px;
  z-index: -4;
  width: 370px;

  @media screen and (max-width: 615px) {
    width: 200px;
    /* display: none; */
    left: 20px;
    bottom: -20px;
  }
`;

const StarfallImage = styled.img`
  position: absolute;
  top: 70px;
  left: 71%;
  width: 125px;
  rotate: -20deg;
  transform: scaleX(-1); 
  z-index: -4;

  @media screen and (max-width: 1100px) {
    top: -10px;
    left: 65%;
    width: 150px;
  }
`;

const GomilkaImage = styled.img`
  position: absolute;
  top: 0;
  left: 50%;
  width: 440px;
  transform: translate(-50%, 0%);
  z-index: -1;
  pointer-events: none;

  @media screen and (max-width: 1100px) {
    z-index: -3;
    width: 300px
  }

  @media screen and (max-width: 615px) {
    display: none;
  }
`;

const MobileGomilkaImage = styled(GomilkaImage)`
  display: none;

  @media screen and (max-width: 615px) {
    display: block;
    z-index: -5;
    width: 150px;
    top: auto;
    left: 65%;
  }
`;

const FlexCards = styled(FlexContainer)`
  position: relative;
 top: -125px;
 height: 125px;
  flex-wrap: nowrap;
  margin-bottom: 60px;

   /* @media screen and (max-width: 1120px) {
    top: 0px;
    height: auto;
  } */

    @media screen and (max-width: 680px) {
    font-size: 20px;
  }
`;

export const HeroCard = styled.div`
  position: relative;
  width: 460px;
  height: 125px;
  z-index: 1;


  @media screen and (max-width: 374px) {
    width: 280px;
  }
`

const HeroCardTop = styled(HeroCard)`
  z-index: -2;
  top: 80px;

    @media screen and (max-width: 1080px) {
      top: 120px;
    }

    @media screen and (max-width: 615px) {
      margin-left: auto;
      width: 270px;
      top: 130px;
      >span {
          font-size: 18px;
      }
    }

`

const HeroCardBottom = styled(HeroCard)`
  top: 60px;
  left: 100px;
  z-index: -3;
  
  >span {
    padding-top: 20px;
  }
      @media screen and (max-width: 1080px) {
        top: 100px;
      >span {
      }
  }

  @media screen and (max-width: 615px){
    top: 110px;
    left: 0px;
    width: 270px;
    >span {
      font-size: 14px;
        padding-top: 18px;
    }
  }
`

export const HeroCardImage = styled.img`
  width: 100%;
  position: absolute;
  left: 0;
  z-index: -1;
`

export const HeroCardText = styled(TextElem) <{ hero?: boolean }>`
  /* position: absolute; */
  width: 440px;
  margin: 10px;

  display: block;
  padding: 12px 25px;

  top: 30px;
  bottom: 37px;
  left: 32px;
  right: 20px;
  z-index: 2;

  @media screen and (max-width: 615px) {
    font-size: 16px;
    margin: 0;
  }

  @media screen and (max-width: 375px) {
    font-size: 10px;

  }
`

const RegisterButtonHolder = styled.div`
position: relative;
top: -120px;
left: 180px;

    @media screen and (max-width: 1120px) {
    gap: 23px;
    height: 200px;
    top: 100px;
    left: auto;
    right: 0px;
  }

  @media screen and (max-width: 615px) {
    display: none;
  }
`;

const MobileRegisterButtonHolder = styled(RegisterButtonHolder)`
  display: none;

  @media screen and (max-width: 615px) {
    display: block;
      gap: 23px;
      height: 250px;
      top: 0px;
      left: auto;
      right: 0px;
      width: 100%;
    }
`;

const RegisterMamaButton = styled(MamaButton)`
  width: 100%;
  justify-content: center;

  @media screen and (max-width: 615px) {
    padding: 0 20px;
  }
`;